export default __webpack_public_path__ + "static/media/catWire-pass-thru-40.3b8ab4fe.svg";